import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac5ea126"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2.5 gordita-400-12 text-Text/text_high" }, "Documentation", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between h-[16px] font-gordita-medium text-[12px] text-Text/text_medium" }, [
  /*#__PURE__*/_createElementVNode("span", null, "About")
], -1))
const _hoisted_5 = { class: "flex justify-between h-[16px] font-gordita-medium text-[11px] text-Text/text_medium" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Incredibuild Version", -1))
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { class: "flex justify-between h-[16px] font-gordita-regular text-[11px] text-Text/text_medium" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Client build", -1))
const _hoisted_10 = { class: "flex justify-between h-[16px] font-gordita-regular text-[11px] text-Text/text_medium" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Manager build", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "flex justify-between items-center h-[16px] font-gordita-regular text-[11px] text-Text/text_medium" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Coordinator ID", -1))
const _hoisted_15 = { class: "flex gap-[8px]" }
const _hoisted_16 = {
  key: 0,
  class: "text-[11px] font-gordita-regular"
}

import elementsIds from '@/const/elementIds.json';
import { IncrediMenu, IncrediList, IncrediItem, IncrediButton } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref } from 'vue';
import { config } from '@/config';
import { useCommonDataQuery, useCoordinatorInfoQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useMatomo } from '@/services/matomo/matomo.service';
import { MatomoCategories, MatomoExternalLinkActions } from '@/services/matomo/matomo.const';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { copyToClipboard } from '@/services/utils';
import { useI18n } from 'vue-i18n';
import { useOsService } from '@/services/OsService/OsService';
import { useRouter } from 'vue-router';
import { Routes } from '@/router/router.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'helpMenu',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "isSelected"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: boolean): void; (e: 'isSelected', value: boolean): void }), expose: any, slots: any, attrs: any }) {


const matomo = useMatomo();
const { t } = useI18n();
const router = useRouter();

// eslint-disable-next-line no-unused-vars

const linksConfig = {
  windows: {
    documentation: process.env.VUE_APP_DOCUMENTATION_PAGE_WINDOWS,
  },
  linux: {
    documentation: process.env.VUE_APP_DOCUMENTATION_PAGE_LINUX,
  },
  mac: {
    documentation: process.env.VUE_APP_DOCUMENTATION_PAGE_MAC,
  },
};

const osService = useOsService();
const coordinatorsService = inject(IKCoordinatorsService);
const coordinatorInfo = useCoordinatorInfoQuery({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' });
const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
const isFreeDevLicense = computed(() => GQL_commonData?.result?.value?.ibManagerEntities?.license?.windows?.isFreeDev);

const copied = ref(false);
const openLinkInNewTab = (url: string) => {
  const urlNamesMap = {
    [linksConfig[osService?.osType.value as OsType].documentation as string]: 'Documentation',
  } as const;
  matomo?.trackEvent({
    category: MatomoCategories.ExternalLink,
    action: MatomoExternalLinkActions.Click,
    name: urlNamesMap[url],
  });
  emit('update:modelValue', false); // Close help menu after clicking on documentation/community
  const win = window.open(url, '_blank');
  win?.focus();
};

const gotToGettingStartedPage = () => {
  router.push({ name: Routes.GettingStarted });
  emit('update:modelValue', false);
};

const gettingStartedSelected = computed(() => router.currentRoute.value.name === Routes.GettingStarted);

const handleCopyCoordinatorId = () => {
  copyToClipboard(coordinatorInfo.result.value?.ibManagerEntities?.coordinatorInfo?.coordinatorId || '');
  copied.value = true;
  setTimeout(() => {
    copied.value = false;
  }, 1500);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createBlock(IbxScopedCss, { class: "!h-full" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediMenu), {
        "model-value": __props.modelValue,
        direction: 'middle-right',
        "offset-y": -70,
        "offset-x": -8,
        "data-testid": _unref(elementsIds).leftDrawer.helpMenu.menuContainer,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => emit('update:modelValue', value ))
      }, {
        content: _withCtx(() => [
          _createVNode(IbxScopedCss, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IncrediList), { class: "w-56" }, {
                default: _withCtx(() => [
                  (_unref(isFreeDevLicense))
                    ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: 0,
                        class: "cursor-pointer",
                        selected: _unref(gettingStartedSelected),
                        "data-testid": _unref(elementsIds).leftDrawer.helpMenu.gettingStartedLink,
                        onClick: gotToGettingStartedPage
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_q_icon, {
                              style: {"font-size":"24px"},
                              class: _normalizeClass([_unref(gettingStartedSelected) ? '' : 'text-Text/text_lowest', "help-menu-icon uil uil-rocket"])
                            }, null, 8, ["class"]),
                            _createElementVNode("div", {
                              class: _normalizeClass([_unref(gettingStartedSelected) ? '' : 'text-Text/text_high', "ml-2.5 gordita-400-12"])
                            }, " Getting Started ", 2)
                          ])
                        ]),
                        _: 1
                      }, 8, ["selected", "data-testid"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IncrediItem), {
                    class: "incredi-transition",
                    "data-testid": _unref(elementsIds).leftDrawer.helpMenu.documentationLink,
                    "data-test-help-menu-documentation-link": linksConfig[_unref(osService)?.osType?.value || _unref(OsType).Windows].documentation,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (openLinkInNewTab(linksConfig[_unref(osService)?.osType?.value || _unref(OsType).Windows].documentation || '')))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_q_icon, {
                          style: {"font-size":"24px"},
                          class: "help-menu-icon uil uil-book-open text-Text/text_lowest"
                        }),
                        _hoisted_3
                      ])
                    ]),
                    _: 1
                  }, 8, ["data-testid", "data-test-help-menu-documentation-link"]),
                  _createVNode(_component_q_separator, { class: "mb-1.5" }),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(IncrediItem), { class: "pointer-events-none !py-[6px] leading-[16px]" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IncrediItem), {
                      "data-testid": _unref(elementsIds).leftDrawer.helpMenu.managerVersionContainer,
                      class: "pointer-events-none !py-[2px] leading-[16px]"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("span", {
                            "data-testid": _unref(elementsIds).leftDrawer.helpMenu.managerVersion
                          }, _toDisplayString(_unref(config).value?.versionInfo?.version), 9, _hoisted_7)
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-testid"]),
                    _createVNode(_unref(IncrediItem), { class: "pointer-events-none !py-[2px] leading-[16px]" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("span", null, _toDisplayString(_unref(config).value?.versionInfo?.clientBuild), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IncrediItem), { class: "pointer-events-none !py-[2px] leading-[16px]" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("span", null, _toDisplayString(_unref(config).value?.versionInfo?.managerBuild), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    (_unref(osService)?.isWindows.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_unref(IncrediItem), { class: "!py-[2px] leading-[16px] !cursor-default" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("div", _hoisted_15, [
                                  (copied.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('helpMenu.copiedCoordinatorIdToClipboard')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(_unref(IncrediButton), {
                                    design: "ghost-grey",
                                    class: _normalizeClass(["w-[16px] h-[16px] !rounded-[50%] flex justify-center", {
                          'pointer-events-none': copied.value,
                        }]),
                                    onClick: handleCopyCoordinatorId
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(["w-[13px] h-[13px] flex text-[13px] uil text-Text/text_low", {
                            'uil-copy': !copied.value,
                            'uil-check': copied.value,
                          }])
                                      }, null, 2)
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["model-value", "data-testid"])
    ]),
    _: 3
  }))
}
}

})